import { BaseMapper } from '@ps/utils';
import { CurrencyDto } from '../dtos/company.dto';
import { Currency } from '../../models/company.model';

export class CurrencyMapper extends BaseMapper<CurrencyDto, Currency> {
  public fromDto({
    fx,
    currencyShortCode,
    currencyFullName,
  }: CurrencyDto): Currency {
    return { fx, currencyShortCode, currencyFullName };
  }
}
